import React, { useState, useEffect } from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './OrderProduct/Main';
import Form from './OrderProduct/Form';

// Utils
import {
  getDataWithComp,
  getAlert,
  getMaxOdNo,
  getClearLocalStorage
} from '../../../utils/SamuiUtils';

const OrderProduct = () => {
  const [mode, setMode] = useState('');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataDetailList, setDataDetailList] = useState([]);
  const [maxOdNo, setMaxOdNo] = useState();

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      setMode('S');
      fetchRealtime();
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp('API_1001_WHDOC_H', `AND WHDoc_Type = '4' ORDER BY WHDoc_No DESC`);
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }

      const detailList = await getDataWithComp('API_1002_WHDOC_D', 'ORDER BY Line ASC');
      if (detailList && detailList.length > 0) {
        setDataDetailList(detailList);
      }

      // หาค่าสูงของ WHDocNo ใน WHDOC_H สำหรับ OD (ใบออเดอร์สินค้า)
      const findMaxOdNo = await getDataWithComp('WHDoc_H', `AND WHDoc_Type = '4' ORDER BY WHDoc_No DESC`);
      const maxOd = getMaxOdNo(findMaxOdNo);
      setMaxOdNo(maxOd);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I')
  };

  const onPageUpdate = (whDocNo) => {
    setMaxOdNo(whDocNo);
    setMode('U')
  };

  return (
    <div>
      <div className="OrderProduct">
        <div className="wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === 'S' ? (
                  <Main
                    name={'ใบออเดอร์สินค้า'}
                    dataMasterList={dataMasterList}
                    dataDetailList={dataDetailList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(whDocNo) => onPageUpdate(whDocNo)}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    setMode={setMode}
                    name={'ใบออเดอร์สินค้า'}
                    whDocNo={maxOdNo}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderProduct;